/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
import connector from '../connector';

const addMonthlyMethanes = (data) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('monthlyMethane', 'readwrite');
        const monthlyMethaneStore = transaction.objectStore('monthlyMethane');

        monthlyMethaneStore.clear(); // delete all of the previously added data to add the new list

        data.forEach(singleData => {
            monthlyMethaneStore.add(singleData);
        });

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getMonthlyMethaneByFarmId = (farmId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('monthlyMethane', 'readonly');
        const monthlyMethaneStore = transaction.objectStore('monthlyMethane');
        const farmIdIndex = monthlyMethaneStore.index('FarmIdIndex');

        const farmMonthlyMethane = farmIdIndex.get(farmId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: farmMonthlyMethane.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getMonthlyMethaneByAnimalId = (animalId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('monthlyMethane', 'readonly');
        const monthlyMethaneStore = transaction.objectStore('monthlyMethane');
        const animalIdIndex = monthlyMethaneStore.index('AnimalIdIndex');

        const animalMonthlyMethane = animalIdIndex.get(animalId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: animalMonthlyMethane.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const monthlyMethane = {
    addMonthlyMethanes,
    getMonthlyMethaneByFarmId,
    getMonthlyMethaneByAnimalId
}

export default monthlyMethane;
